import defaultViewReducers from 'common/src/app/reducers/view/defaultViewReducers';
import combineReducersNamed from 'common/src/app/util/reducers/combineReducersNamed';
import pages from './pagesReducer';

export default combineReducersNamed({
  ...defaultViewReducers,
  pages,
});
